import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useContent } from '../contexts/ContentContext';

const Experts = () => {
  const { getContent } = useContent();
  const pageHeader = getContent('experts.pageHeader') || {};
  const team = getContent('experts.team') || {};
  const expertsCta = getContent('experts.cta') || {};
  
  const trainers = team.trainers || [];

  useEffect(() => {
    // Handle hash navigation on page load
    if (window.location.hash) {
      setTimeout(() => {
        const element = document.getElementById(window.location.hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, []);

  return (
    <div className="experts-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <div className="page-header-content">
            <h1>{pageHeader.title || 'Notre Équipe d\'Experts'}</h1>
            <p>{pageHeader.subtitle || 'Rencontrez les formateurs de renommée internationale qui transforment l\'avenir de la dentisterie'}</p>
          </div>
        </div>
      </section>

      {/* Nos Formateurs */}
      <section className="expert-team" id="expert-team">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">{team.title || 'Nos Formateurs Experts'}</h2>
            <p className="section-subtitle">
              {team.subtitle || 'Rencontrez notre équipe de formateurs qualifiés qui transforment votre pratique dentaire'}
            </p>
          </div>
          
          <div className="trainers-grid">
            {trainers.map((trainer, index) => (
              <div key={trainer.id} className="trainer-card">
                {/* Top Section: Photo + Name/Title + Specialties filling space */}
                <div className="trainer-top-section">
                  <div className="trainer-header">
                    <div className="trainer-photo">
                      {trainer.photo ? (
                        <img src={trainer.photo} alt={trainer.name} />
                      ) : (
                        <div className="trainer-photo-placeholder">
                          <i className="fas fa-user-md"></i>
                        </div>
                      )}
                    </div>
                    
                    <div className="trainer-info">
                      <h3 className="trainer-name">{trainer.name}</h3>
                      <p className="trainer-title">{trainer.title}</p>
                    </div>
                  </div>
                  
                  <div className="trainer-specialties">
                    {trainer.specialties.map((specialty, specialtyIndex) => (
                      <span key={specialtyIndex} className="specialty-tag">{specialty}</span>
                    ))}
                  </div>
                </div>
                
                {/* Bottom Section: CV */}
                <div className="trainer-cv">
                  <h4>Curriculum Vitae</h4>
                  <div className="cv-section">
                    <div className="cv-item">
                      <strong>Expérience:</strong>
                      <span>{trainer.cv.experience}</span>
              </div>
                    <div className="cv-item">
                      <strong>Certifications:</strong>
                      <ul>
                        {trainer.cv.certifications.map((cert, certIndex) => (
                          <li key={certIndex}>{cert}</li>
                        ))}
                      </ul>
                  </div>
                    <div className="cv-item">
                      <strong>Réalisations:</strong>
                      <ul>
                        {trainer.cv.achievements.map((achievement, achIndex) => (
                          <li key={achIndex}>{achievement}</li>
                        ))}
                      </ul>
                </div>
              </div>
            </div>

                <div className="trainer-formations">
                  <h4>Formations Animées</h4>
                  <div className="formations-list">
                    {trainer.formations.map((formation, formIndex) => (
                      <div key={formIndex} className="formation-item">
                        <i className="fas fa-graduation-cap"></i>
                        <span>{formation}</span>
                </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta">
        <div className="container">
          <div className="cta-content">
            <h2>{expertsCta.title || 'Prêt à Transformer Votre Pratique ?'}</h2>
            <p>{expertsCta.subtitle || 'Rejoignez plus de 500 dentistes qui ont fait confiance à DentoXcellence pour leur développement professionnel'}</p>
            <div className="cta-buttons">
              {(expertsCta.buttons || []).map((button, index) => (
                button.link?.startsWith('http') ? (
                  <a key={index}
                     href={button.link} 
                     className={`btn btn-${button.type}`}
                     target="_blank" 
                     rel="noopener noreferrer">
                    <i className={button.icon}></i>
                    {button.text}
                  </a>
                ) : (
                  <Link key={index} to={button.link} className={`btn btn-${button.type}`}>
                    <i className={button.icon}></i>
                    {button.text}
                  </Link>
                )
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Experts;


